import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CurrentratesService {
  private subject = new Subject<any>();
  public currentRates: any = [];

  constructor(private http: HttpClient) { }
  sendObject(message: object) {
    // console.log("before publishing next method");
    this.subject.next({ message });
    // console.log("after publishing next method");
  }
 
  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
}
